<div [class.dark]="darkBackground">
  <a
    appButton
    name="made-with-picflow"
    location="view-gallery-page"
    weight="bold"
    [hasIcon]="true"
    color="default-opacity"
    href="https://picflow.com/?utm_campaign=badge_premium&utm_source=picflow&utm_medium=organic&utm_content={{
      tenantId
    }}"
    target="_blank"
    class="made-with-picflow small-icon"
    shape="round"
    height="0"
    size="0"
  >
    <app-svg src="/assets/icons/logo/picflow.svg"></app-svg>
    <span>Made with Picflow</span>
  </a>
</div>
